import React, { Component } from "react";
import "./workExperience.scss";
import Slider from "react-slick";
import PropTypes from "prop-types";

class WorkExperience extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    const workExperiences = this.props.workExperience;
    return (
      <div>
        <section id="work-experience" className="p-0">
          <h1 className="pt-2 title-2 title-md-1">My work experience</h1>

          <div className="row p-0">
            <div className="col-12 px-3">
              <Slider {...settings}>
                {workExperiences.map((experience, index) => {
                  return (
                    <div key={index}>
                      <div className="card work-experience-card-mobile">
                        <div className="card-body">
                          <h4 className="card-title text-3">
                            <strong>{experience.designation}</strong>
                          </h4>
                          <h4 className="text-4">
                            <strong>{experience.companyName}</strong>
                          </h4>
                          <p className="text-6">{experience.duration}</p>
                          <div className="work-responsibility">
                            <ul style={{ paddingInlineStart: '20px' }}>
                              {experience.responsibilities.map((item, index) => {
                                return (
                                  <li key={index}>
                                    <p key={index} className="text-5">{item}</p>
                                  </li>
                                );
                              })}
                            </ul>
                            {/* <p className="color-lighter text-5">Skills:</p>
                            <h6 className="text-5">{experience.skills}</h6> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

WorkExperience.propTypes = {
  workExperience: PropTypes.array.isRequired,
};

export default WorkExperience;
